/**
 * The editor class name
 */
var EDITOR_CLASS_NAME = 'remirror-editor';
/**
 * The editor class selector
 */

var EDITOR_CLASS_SELECTOR = ".".concat(EDITOR_CLASS_NAME);
/**
 * The css class added to a node that is selected.
 */

var SELECTED_NODE_CLASS_NAME = 'ProseMirror-selectednode';
/**
 * The css selector for a selected node.
 */

var SELECTED_NODE_CLASS_SELECTOR = ".".concat(SELECTED_NODE_CLASS_NAME);
/**
 * Explanation from `@atlaskit` ProseMirror uses the Unicode Character 'OBJECT
 * REPLACEMENT CHARACTER' (U+FFFC) as text representation for leaf nodes, i.e.
 * nodes that don't have any content or text property (e.g. hardBreak, emoji,
 * mention, rule) It was introduced because of
 * https://github.com/ProseMirror/prosemirror/issues/262 This can be used in an
 * input rule regex to be able to include or exclude such nodes.
 */

var LEAF_NODE_REPLACING_CHARACTER = "\uFFFC";
/**
 * The null character.
 *
 * See {@link https://stackoverflow.com/a/6380172}
 */

var NULL_CHARACTER = '\0';
/**
 * A character useful for separating inline nodes.
 *
 * @remarks
 * Typically used in decorations as follows.
 *
 * ```ts
 * document.createTextNode(ZERO_WIDTH_SPACE_CHAR)
 * ```
 *
 * This produces the html entity '8203'
 */

var ZERO_WIDTH_SPACE_CHAR = "\u200B";
/**
 * Used to determine the side where a gap-cursor is drawn
 */

var Side;
/**
 * A default empty object node. Useful for resetting the content of a
 * prosemirror document.
 */

(function (Side) {
  Side["LEFT"] = "left";
  Side["RIGHT"] = "right";
})(Side || (Side = {}));

var EMPTY_PARAGRAPH_NODE = {
  type: 'doc',
  content: [{
    type: 'paragraph'
  }]
};
/**
 * The default extension priority level
 */

var DEFAULT_EXTENSION_PRIORITY = 3;
/**
 * Marks are categorized into different groups. One motivation for this was to
 * allow the `code` mark to exclude other marks, without needing to explicitly
 * name them. Explicit naming requires the named mark to exist in the schema.
 * This is undesirable because we want to construct different schemas that have
 * different sets of nodes/marks.
 */

var MarkGroup;

(function (MarkGroup) {
  MarkGroup["FontStyle"] = "fontStyle";
  MarkGroup["Link"] = "link";
  MarkGroup["Color"] = "color";
  MarkGroup["Alignment"] = "alignment";
  MarkGroup["Indentation"] = "indentation";
  MarkGroup["Behavior"] = "behavior";
  MarkGroup["Code"] = "code";
})(MarkGroup || (MarkGroup = {}));

var NodeGroup;
/**
 * Defines the type of the extension.
 */

(function (NodeGroup) {
  NodeGroup["Inline"] = "inline";
  NodeGroup["Block"] = "block";
})(NodeGroup || (NodeGroup = {}));

var ExtensionType;
/**
 * These are the default supported tag strings which help categorize different
 * behaviors that extensions can exhibit.
 *
 * @remarks
 *
 * Any extension can register itself with multiple such behaviors and these
 * categorizations can be used by other extensions when running commands and
 * updating the document.
 */

(function (ExtensionType) {
  ExtensionType["Node"] = "node";
  ExtensionType["Mark"] = "mark";
  ExtensionType["Plain"] = "plain";
})(ExtensionType || (ExtensionType = {}));

var Tags;
/**
 * The toString return value for any created remirror class.
 */

(function (Tags) {
  Tags["LastNodeCompatible"] = "lastNodeCompatible";
  Tags["FormattingMark"] = "formattingMark";
  Tags["FormattingNode"] = "formattingNode";
  Tags["NodeCursor"] = "nodeCursor";
})(Tags || (Tags = {}));

var RemirrorClassName;

(function (RemirrorClassName) {
  RemirrorClassName["Extension"] = "$$RemirrorExtension";
})(RemirrorClassName || (RemirrorClassName = {}));

export { DEFAULT_EXTENSION_PRIORITY, EDITOR_CLASS_NAME, EDITOR_CLASS_SELECTOR, EMPTY_PARAGRAPH_NODE, ExtensionType, LEAF_NODE_REPLACING_CHARACTER, MarkGroup, NULL_CHARACTER, NodeGroup, RemirrorClassName, SELECTED_NODE_CLASS_NAME, SELECTED_NODE_CLASS_SELECTOR, Side, Tags, ZERO_WIDTH_SPACE_CHAR };
//# sourceMappingURL=core-constants.esm.js.map
